// ============================================================
// UTILIDADES PARA CONTENIDO - NO MODIFICAR
// ============================================================
// Este archivo proporciona funciones auxiliares para acceder
// al contenido de forma segura, con valores por defecto.
// ============================================================

import siteContent from './siteContent';

/**
 * Obtiene un valor del contenido de forma segura
 * Si no existe, retorna el valor por defecto
 */
export const getContent = (path, defaultValue = '') => {
  try {
    const keys = path.split('.');
    let value = siteContent;
    
    for (const key of keys) {
      if (value && typeof value === 'object' && key in value) {
        value = value[key];
      } else {
        return defaultValue;
      }
    }
    
    return value ?? defaultValue;
  } catch {
    return defaultValue;
  }
};

/**
 * Genera un link de WhatsApp con mensaje personalizado
 */
export const getWhatsAppLink = (customMessage = null) => {
  const number = getContent('contact.whatsapp.number', '526561975200');
  const message = customMessage || getContent('contact.whatsapp.defaultMessage', 'Hola, me interesa información');
  return `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
};

/**
 * Obtiene una imagen con fallback
 */
export const getImage = (key, fallback = '/images/logo-confiare.png') => {
  return getContent(`images.${key}`, fallback);
};

/**
 * Obtiene información de contacto
 */
export const getContactInfo = () => ({
  phone: getContent('contact.phone', '(656) 536-7364'),
  phoneLink: getContent('contact.phoneLink', 'tel:6565367364'),
  email: getContent('contact.email', 'credito@confiare.mx'),
  address: getContent('contact.address', 'Ciudad Juárez, Chihuahua'),
  hours: getContent('contact.hours', 'Lunes a Viernes: 9:00 AM - 6:00 PM'),
  whatsappLink: getWhatsAppLink()
});

/**
 * Obtiene las redes sociales
 */
export const getSocialLinks = () => ({
  facebook: getContent('socialLinks.facebook', '#'),
  instagram: getContent('socialLinks.instagram', '#'),
  tiktok: getContent('socialLinks.tiktok', '#')
});

export default {
  getContent,
  getWhatsAppLink,
  getImage,
  getContactInfo,
  getSocialLinks
};
